import { ContractSchema, CustomerSchema } from '@weft/types';
import { oz } from '@weft/utils';

export const ContractPageDataSchema = oz.object({
  contract: ContractSchema.extend({
    customer: CustomerSchema,
    revenue: oz.number(),
  }),
}).openapi('ContractPageData');

export type ContractPageData = oz.infer<typeof ContractPageDataSchema>;